import { queryOptions } from '@tanstack/react-query';

import { api } from '#client';
import { parseSchema } from '#client/validation';

import { ClaimFilters } from './claims.types';
import { Stats } from './stats.types';

const getStats = async (filters: ClaimFilters): Promise<Stats> =>
	api
		.get('/claims/dashboardmetrics', {
			params: filters,
		})
		.then(parseSchema(Stats));

export const statsQueries = {
	all: ['stats'],
	stats: (filters: ClaimFilters) =>
		queryOptions({
			queryKey: [...statsQueries.all, filters],
			queryFn: () => getStats(filters),
		}),
};
